import styled from "@emotion/styled";
import { Icon, Link, List, Navbar, NavRight, NavTitle as F7NavTitle, Popup, Searchbar } from "framework7-react";
import { useState } from "react";

import { ActivityStarterListItem } from "@/components/ActivityStarterListItem";
import { NewActivityStarterButton } from "@/components/NewActivityStarterButton";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { useIdentifier } from "@/hooks/useIdentifier";
import { usePopupPageReady } from "@/hooks/usePopupPageReady";
import { useSearchActivities } from "@/hooks/useSearchActivities";
import { AppBridgeProvider } from "@/providers/AppBridgeProvider";

const NavTitle = styled(F7NavTitle)`
  &&& {
    width: 100%;
    height: 100%;

    a {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      gap: 0.5rem;
    }
  }
`;

const Footer = styled.div`
  position: relative;
  bottom: 0;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  left: 0;
  right: 0;
  padding: 1rem 1rem calc(1rem + var(--f7-safe-area-bottom)) 1rem;
`;

export const ActivitySearchPopupPage = createPage("ActivitySearchPopupPage", PageComponent);

function PageComponent({ pageName, f7router, ...routeProps }: PageComponentProps) {
  const { getPageProps, isPageReady, swipeHandler } = usePopupPageReady(pageName);

  const [keyword, setKeyword] = useState("");
  const activities = useSearchActivities(keyword, { skip: !isPageReady });
  const searchbarClassName = useIdentifier({ prefix: "searchbar" });

  return (
    <AppBridgeProvider
      f7router={f7router}
      isVisible={isPageReady}
      {...routeProps}
    >
      <Popup
        data-component={pageName}
        {...getPageProps()}
      >
        {swipeHandler}
        <Navbar sliding>
          <NavTitle>
            <Link
              className="no-ripple"
              href="#"
              searchbarEnable={"." + searchbarClassName}
            >
              <Icon material="search" />
              <span>何をしていますか？</span>
            </Link>
          </NavTitle>
          <NavRight>
            <Link
              popupClose
              href="#"
            >
              <Icon material="close" />
            </Link>
          </NavRight>
          <Searchbar
            customSearch
            expandable
            className={searchbarClassName}
            placeholder="何をしていますか？"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            onClickClear={() => setKeyword("")}
          />
        </Navbar>
        <List>
          {activities.map((activity) => (
            <ActivityStarterListItem
              key={activity.id}
              activity={activity}
              onCompleted={() => f7router.back()}
            />
          ))}
        </List>
        <Footer>
          <NewActivityStarterButton
            activityName={keyword}
            onCompleted={() => f7router.back()}
          />
        </Footer>
      </Popup>
    </AppBridgeProvider>
  );
}
